import { useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";

import UpdateAvailableBanner from "../components/UpdateAvailableBanner";

const ROUTE_ARG = "route";

export default function RouteFromArg() {
	const [queryParams] = useSearchParams();
	const navigate = useNavigate();
	const [wasRouteChecked, setWasRouteChecked] = useState(false);

	useEffect(() => {
		if (queryParams.size > 0) {
			const route = queryParams.get(ROUTE_ARG);
			if (route) {
				queryParams.delete(ROUTE_ARG);
				const reroute =
					queryParams.size === 0 ? route : `${route}/?${queryParams.toString()}`;
				navigate(reroute);
			}
		}
		setWasRouteChecked(true);
	}, []);

	if (!wasRouteChecked) return null;
	return (
		<>
			<Outlet />
			{/*
				This is the outermost route element, so it stays mounted across
				navigation. The banner has to live inside the router to notice a
				route change, which is what tells it someone is still working in
				a tab they opened before a deploy.
			*/}
			<UpdateAvailableBanner />
		</>
	);
}
